app.service('deliveryPointModal', function (modal, front, deliveryPointAutocomplete,
	deliveryPointLocation, tooltip,
	orderConfig, loading, geolocation, console, broker, html) {
	let locations = [];
	let images = {};
	let gMarkers = [];
	let visibleMarkers = [];
	let selectedTypes = [];
	let $self, $parcelType, $selectAll;
	let map, markerClusterer, autocompleteInput, selectedPointCallback;
	let initiated = false;
	let config;
	let selectedPoint;
	let imgPath = "/img/rwd/google-maps/";
	let staticDomain;
	let deliveryType;

	function markerClustererStyle() {
		return [
			{
				width: 53,
				height: 53,
				url: staticDomain + imgPath + "m1.png",
				textColor: "#ffffff",
				textSize: 10,
			},
			{
				width: 56,
				height: 56,
				url: staticDomain + imgPath + "m2.png",
				textColor: "#ffffff",
				textSize: 11,
			},
			{
				width: 66,
				height: 66,
				url: staticDomain + imgPath + "m3.png",
				textColor: "#ffffff",
				textSize: 12,
			},
			{
				width: 78,
				height: 78,
				url: staticDomain + imgPath + "m4.png",
				textColor: "#ffffff",
				textSize: 12,
			},
			{
				width: 90,
				height: 90,
				url: staticDomain + imgPath + "m5.png",
				textColor: "#ffffff",
				textSize: 12,
			},
		];
	}

	function fetchPoints() {
		const lockers = '/web-cached/collection-parcel-machines.ltr';
		const pickupPoints = '/web-cached/collection-pickup-points.ltr';
		const shops = '/web-cached/collection-shops.ltr';
		deliveryType = config.pageType == 'basket' ? config.deliveryTypeName : config.deliveryType;
		return $.ajax({
			url: (deliveryType == 'inpost' ? lockers : (deliveryType == 'pickupPoint' ? pickupPoints : shops))
		});
	}

	function fetchSelectedPoint(id) {
		const lockers = '/web-cached/parcel-machine-details.ltr?code=' + id;
		const pickupPoints = '/web-cached/pickup-point-details.ltr?code=' + id;
		const shopDetailsEndpoint = config.pageType == 'basket' ? '/cart-shop-details.ltr' : '/shop-details.ltr';
		const shops = shopDetailsEndpoint + '?code=' + id + (config.pageType !== 'basket' && config.deliveryInfo && config.deliveryInfo.taxfree ? '&taxFree=true' : '');
		return $.ajax({
			url: (deliveryType == 'inpost' ? lockers : (deliveryType == 'pickupPoint' ? pickupPoints : shops))
		});
	}

	function mapStart(params) {
		const mapOptions = {
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			streetViewControl: false,
			minZoom: 6,
			clickableIcons: false,
			fullscreenControl: false
		};
		let myLatLng;
		let zoom;
		if (params.lat && params.lng) {
			zoom = deliveryType == 'shop' ? 13 : 16;
			myLatLng = new google.maps.LatLng(params.lat, params.lng);
		} else {
			zoom = 6;
			myLatLng = new google.maps.LatLng(51.803754, 19.5707663);		// polska cała
		}
		map = new google.maps.Map(document.getElementById("map"), mapOptions);
		showPlaceOnMap(myLatLng, zoom);
		const styles = markerClustererStyle();
		markerClusterer = new MarkerClusterer(map, visibleMarkers, {
			imagePath: staticDomain + imgPath + "m",
			styles: styles
		});
	}

	function addMarkersToMap() {
		if (map) {
			markerClusterer.clearMarkers();
			markerClusterer.addMarkers(visibleMarkers);
		}
	}

	function showMarkers(brands) {
		visibleMarkers = [];
		gMarkers.forEach(function (marker) {
			if (brands.length === 0 || $.inArray(marker.brand, brands) > -1) {
				visibleMarkers.push(marker);
			}
		})
		addMarkersToMap();
	}

	function populateMarkers() {
		gMarkers = [];
		let visibleTypes = [];
		locations.forEach((element, i) => {
			if (element[5] && deliveryType == 'pickupPoint' && config.availablePickupPointKinds && config.availablePickupPointKinds.indexOf(element[5]) === -1) {
				return;
			}
			let brand = (deliveryType == 'inpost' ? 'INPOST' : (deliveryType == 'shop' ? 'SHOP' : element[3]));
			visibleTypes.push(brand);
			let img = '';
			if (deliveryType == 'inpost' && images['inpost']) {
				img = images['inpost'];
			} else if (deliveryType == 'shop') {
				img = staticDomain + imgPath + 'shop.png';
			} else if (deliveryType == 'pickupPoint' && images[element[3]]) {
				img = images[element[3]];
			}
			const factory = new google.maps.Marker({
				brand: brand,
				position: { lat: parseFloat(element[2]), lng: parseFloat(element[1]) },
				icon: img
			});
			gMarkers.push(factory);
			google.maps.event.addListener(factory, "click", function () {
				const clickedMarker = this;
				console.log('Pobranie danych punktu z mapy: ' + element[0] + ' [' + element[3] + ']');
				const $info = $('#selected-point');
				$info.addClass('loading');
				fetchSelectedPoint(element[0]).then(function (responseHtml) {
					const version = html.has('points-on-modal') ? 'new' : 'old';
					responseHtml = responseHtml.indexOf('new-version') > -1 ? $('<div>' + responseHtml + '</div>').find(version === 'new' ? '.new-version' : '.old-version').html() : responseHtml;
					// jak będzie tylko jedna wersja warunek będzie do usunięcia i sprzątamy tylko w jsp/tagach
					selectedPoint = {
						id: element[0],
						html: responseHtml,
						lat: parseFloat(element[2]),
						lng: parseFloat(element[1])
					}
					$('#selected-delivery-point').html(responseHtml);
					map.panTo(clickedMarker.getPosition());
					map.panBy(0, 50);
					tooltip.setEventOnElement($info);

					$info.removeClass('hidden loading').attr('tabindex', 0);
					setTimeout(function () {
						$info.focus();
					}, 300);
					$info.find('.js-delivery-point').removeAttr('tabindex').removeAttr('role');
				}).fail(onFetchSelectedPointError);
			});
		});
		visibleTypes = [...new Set(visibleTypes)];
		//console.log(visibleTypes)
		$parcelType.not($selectAll).each(function () {
			let $this = $(this);
			if (!visibleTypes.includes($this.data('type'))) {
				$this.remove();
			}
		});
	}

	function setLocations(data) {
		locations = data.locations;
		images = data.images;
	}

	function setElements() {
		$self = html.has('points-on-modal') ? $('#delivery-points-map-modal') : $('#modal-delivery-points');
		$parcelType = $('.js-parcel-type', $self);
		$selectAll = $('.js-parcel-type[data-type=0]', $self);
		autocompleteInput = $('.place-search', $self)[0];
	}

	function setSelectedParcelType(value) {
		if (value == '0') {
			selectedTypes = [];
		} else {
			const idx = $.inArray(value, selectedTypes);
			if (idx == -1) {
				selectedTypes.push(value);
			} else {
				selectedTypes.splice(idx, 1);
			}
		}
	}
	function hidePreview() {
		$('#selected-point').addClass('hidden').removeAttr('tabindex');
	}

	function setEvents() {
		$self.on('click', '.js-selected-point-close', function () {
			hidePreview();
		}).on('click', '.js-delivery-points-search', function () {
			$self.addClass('search-geolocation');
			var $this = $(this);
			geolocation.findPosition(function (position) {
				$self.removeClass('search-geolocation');
				$this.attr({
					latitude: position.latitude,
					longitude: position.longitude
				});
				showPlaceOnMap({
					lat: position.latitude,
					lng: position.longitude,
				});
			}, function (error) {
				$self.removeClass('search-geolocation');
			});
		}).on('click', '.js-parcel-type', function () {
			const parcelName = $(this).data('type');
			setSelectedParcelType(parcelName);
			$parcelType.removeClass('selected');
			if (!selectedTypes.length) {
				$selectAll.addClass('selected');
			} else {
				selectedTypes.forEach(function (t) {
					$parcelType.filter('[data-type="' + t + '"]').addClass('selected');
				});
			}
			showMarkers(selectedTypes);
		}).on('click', '.js-choose-point', function () {
			hidePreview();
			selectedPointCallback(selectedPoint);
			modal.close();
		}).on('click', '.js-search-button', function () {
			if (autocompleteInput.value != '') {
				deliveryPointLocation.findPlaceByAddress(autocompleteInput.value, function (location, partialMatch, bounds) {
					if (location && !partialMatch) {
						showPlaceOnMap(location, null, bounds);
					} else {
						showEmptyResults();
					}
				});
			}
		});

		deliveryPointAutocomplete.setAutocomplete(autocompleteInput, function (location, bounds) {
			if (location) {
				showPlaceOnMap(location, null, bounds);
			}
		}, function () {
			showEmptyResults();
		});
	}
	function showEmptyResults() {
		$self.addClass('empty-location');
		$('.empty-location-message strong', $self).text($.trim(autocompleteInput.value));
	}
	function showPlaceOnMap(latLng, zoom, bounds) {
		$self.removeClass('empty-location');
		map.setCenter(latLng);
		if (zoom) {
			map.setZoom(zoom);
		} else if (bounds) {
			map.fitBounds(bounds);
		}
	}
	broker.on('BEFORE_PAGE_CHANGE', function () {
		initiated = false;
	});

	function open(params, callback) {
		staticDomain = front.getParam('staticDomain');
		var modalOptions = {
			modifier: 'remodal-full-height'
		}
		if (!initiated) {
			config = orderConfig.getData();
			loading.start();
			fetchPoints().then(function (data) {		// przykład: [	[ "typ", "id", longitude, latitude ], [ "SHOP_ZABKA", "DHL POP ŻABKA", 21.0390077, 52.26276 ]]
				loading.stop();
				setElements();
				setEvents();
				setLocations(data);
				populateMarkers();
				autocompleteInput.value = params.input;
				if (!html.has('points-on-delivery')) {
					modal.open('delivery-points', modalOptions);
				}
				mapStart(params);
				showMarkers(selectedTypes);
				initiated = true;
			}).fail(onFetchPointsError);
		} else {
			autocompleteInput.value = params.input;
			modal.open('delivery-points', modalOptions);
			showPlaceOnMap(params);
		}
		selectedPointCallback = callback;
	}

	function onFetchPointsError(e) {
		console.log(e);
		loading.stop();
		modal.alert("Błąd pobierania punktów odbioru. Spróbuj ponownie za chwilę.");
	}

	function onFetchSelectedPointError(e) {
		console.log(e);
		modal.alert("Błąd pobierania wybranego punktu odbioru. Spróbuj ponownie za chwilę.");
	}

	return {
		open
	};
});
